import React, { useContext, useState } from 'react'
import CustomInput from '../../../../components/CustomInputs/CustomInput'
import CustomSelectInput from '../../../../components/CustomSelectInput/CustomSelectInput'
import { Badge, Label, Textarea } from 'flowbite-react'
import { UserContext } from '../../../../contexts/UserContext'
import showToast from '../../../../components/CustomToast/toastHelper'
import client from '../../../../api/client'
import FileUploadCard from '../../../../components/FileUploadCard/FileUploadCard'
import { serialize } from 'object-to-formdata'

const BusinessProfile = () => {
    const {userDetails} = useContext(UserContext) ??{}
    const [inputs, setInputs]= useState<any>({
        currentPassword:"",
        newPassword:"",
        confirmPassword:""
    })

    const [logo, setLogo] = useState<File | null>();

    // const changePassword = async() =>{
    //     if(inputs.newPassword !== inputs.confirmPassword){
    //         showToast("Passwords do not match", "error");
    //         return
    //     }
    //     const payload = {
    //         password:inputs.currentPassword,
    //         newPassword:inputs.newPassword
    //       };
      
    //       try {
    //         const response = await client.post('/subsidiary/dashboard/change-password', payload);
    //         const message = response?.data?.message;
    //         showToast(message, 'success');
    //         setInputs({currentPassword:'',newPassword:"",confirmPassword:""})
    //       } catch (err: any) {
    //         if (err?.response?.data?.message === 'Please login again') {
    //           sessionStorage.clear();
    //           window.location.href = '/';
    //         } else {
    //           const message = err?.response?.data?.message;
    //           console.error('error getting data', err);
    //           showToast(message, 'error');
    //         }
    //       }
    // }

    const changeLogo = async() =>{
        if (!logo) {
            showToast("Please select a logo to upload", "error");
            return;
        }
        const payload = {
            Logo:logo,
          };

          const dataToSend = serialize(payload)
      
          try {
            const response = await client.post('/subsidiary/dashboard/business/logos/add-or-update', dataToSend, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            const message = response?.data?.message;
            showToast(message, 'success');
            setLogo(null)
          } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
              sessionStorage.clear();
              window.location.href = '/';
            } else {
              const message = err?.response?.data?.message;
              console.error('error getting data', err);
              showToast(message, 'error');
            }
          }
    }
    
    return (
        <div className='my-6 '>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-8'>
                <div>
                    <p className='text-3xl font-semibold'>Business Information</p>
                    <p>Enter your business information and ensure they are correct</p>
                </div>
                <div>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                        <CustomInput label='Business name' name='businessName' value={userDetails.activeSubsidiary.businessName} />
                        <CustomInput label='Business Email' name='businessEmail' value={userDetails.activeSubsidiary.supportEmail}/>
                        <CustomInput label='Business category' name='businessCategory'  value={userDetails.activeSubsidiary.businessType} />
                        <CustomInput label='Legal business name' name='legalBusinessName' value={userDetails.activeSubsidiary.legalBusinessName} />
                    </div>
                    <div>
                        <div className="mb-2 block">
                            <Label htmlFor="description" value="Description" />
                        </div>
                        <Textarea id="description" rows={10} value={userDetails.activeSubsidiary.description} />
                    </div>
                    <div className='my-4'>
                        <p className='text-sm'>Verification Status:</p>
                        <Badge className='text-lg' color={userDetails.activeSubsidiary.verificationStatus === 'Active' ? 'success' : 'warning'}>
                            {userDetails.activeSubsidiary.verificationStatus}
                        </Badge>
                    </div>
                </div>
            </div>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-8 my-24'>
                <div>
                    <p className='text-3xl font-semibold'>Business Logo</p>
                </div>
                <div>
                <div className='my-4'>
                        <FileUploadCard label='Change Business Logo' current={logo} onChange={(file)=>setLogo(file)}/>
                    </div>

                    <div className='w-full my-4 flex justify-between'>
                        <div></div>
                        <div className='flex gap-4'>
                            <button className='border px-6 py-4 rounded-lg text-md font-semibold'>Cancel</button>
                            <button className='border px-6 py-4 rounded-lg bg-custom-button-green text-md font-semibold hover:bg-green-900 hover:text-white' onClick={()=>changeLogo()}>Save changes</button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default BusinessProfile
